import { ApiProperty } from "@nestjs/swagger";


export class EmployeeAttDateRequest {
    @ApiProperty()
    employeeCode: string;

    @ApiProperty()
    startDate: Date;

    @ApiProperty()
    endDate: Date;

    @ApiProperty()
    departmentId?: number;

    @ApiProperty()
    unitId?: number;

    @ApiProperty()
    shift?: string;

    /**
     * 
     * @param employeeCode 
     * @param startDate 
     * @param endDate 
     * @param departmentId 
     * @param unitId 
     * @param shift 
     */

    constructor(employeeCode: string, startDate: Date, endDate: Date, departmentId?: number, unitId?: number, shift?: string) {

        this.employeeCode = employeeCode;
        this.startDate = startDate;
        this.endDate = endDate;
        this.departmentId = departmentId;
        this.shift = shift;
        this.unitId = unitId;

    }

}